import type { Language } from '@/hooks/useTranslations';

// German path mappings (English path -> German path)
const dePathMapping: Record<string, string> = {
  '/contact': '/kontakt',
  '/about': '/ansatz',
  '/speaking': '/programme',
  '/method': '/system',
  '/podcast': '/podcast',
  '/blog': '/blog',
  '/privacy': '/privacy',
  '/terms': '/terms',
  '/lexikon': '/lexikon',
  '/courses': '/kurse',
  '/book': '/buch',
  '/knowledge': '/wissen',
  '/my-courses': '/meine-kurse',
};

/**
 * Get localized path based on language
 * Maps English paths to German slugs when language is 'de'
 * Adds /en prefix when language is 'en'
 */
export const getLocalizedPath = (path: string, language: Language): string => {
  if (language === 'en') {
    return `/en${path}`;
  }
  return dePathMapping[path] || path;
};
